$(function(){
	$('.imageScroller').flickity({
		adaptiveHeight: false,
		cellAlign: 'left',
		contain: true,
		draggable: true,
		pageDots: true,
		prevNextButtons: true,
		pauseAutoPlayOnHover: true,
		setGallerySize: true,
		wrapAround: true
	});
});